import Button from "@/components/Button";
import Dialog from "@/components/Dialog";

type CancelRegistrationInfoModalProps = {
  open: boolean;
  onClosed: () => void;
};

/**
 * Explains why Cancel Registration is visible but not currently performable
 * (PAT events while registration is still open).
 */
export default function CancelRegistrationInfoModal({ open, onClosed }: CancelRegistrationInfoModalProps) {
  return (
    <Dialog
      open={open}
      onClosed={onClosed}
      headline="Cancel Registration Unavailable"
      className="max-w-[560px] p-6 pr-2"
      hasFormElements={false}
      actions={
        <Button variant="filled" onClick={onClosed} testId="cancel-registration-info-close">
          Got It
        </Button>
      }
    >
      <div tabIndex={0} className="flex flex-col gap-3 text-sys-brand-on-surface-variant pb-2">
        <p className="text-body-medium">
          Staff cancellation in Member 360 is only available after registration closes. While registration is open,
          cancellations must be completed by the registrant (self-serve).
        </p>
        <p className="text-body-medium">
          If the Section needs this person removed before registration closes, use Assume User to cancel on their
          behalf.
        </p>
      </div>
    </Dialog>
  );
}
